/**
 * Design tokens of the People Rock communication manual.
 * `brand/brand.config.json` is the editable contract for people and AI tools; this file maps it
 * onto semantic names consumed by MUI and the application.
 */
import { brandConfig } from './brand/brandConfig';

export { brandConfig } from './brand/brandConfig';

export const brandColors = {
  ...brandConfig.palette,
  basalto: brandConfig.palette.petroleo,
  areia: brandConfig.palette.offWhite,
  pedra: brandConfig.palette.nevoa,
  terracota: brandConfig.palette.coral,
  terracotaClara: brandConfig.palette.coral,
  salvia: brandConfig.palette.menta,
  lago: brandConfig.palette.petroleo,
} as const;

export const colors = {
  superficie: brandColors.offWhite,
  superficieElevada: brandColors.branco,
  tinta: brandColors.petroleo,
  tintaSuave: brandConfig.support.tintaSuave,
  linha: brandColors.nevoa,
  acento: brandColors.coral,
  acentoTexto: brandColors.coralEscuro,
  sobreAcento: brandColors.petroleoEscuro,
  bemEstar: brandColors.menta,
  bemEstarTexto: brandColors.petroleo,
  digital: brandColors.sol,
  foco: brandColors.petroleo,
} as const;

/**
 * Qualitative palette for charts. Components choose the foreground from the semantic palette;
 * light fills are intentionally included for the calm/wellbeing parts of the system.
 */
export const chartPalette = [
  brandColors.coral,
  brandColors.petroleo,
  brandColors.menta,
  brandColors.sol,
  brandColors.coralEscuro,
  colors.tintaSuave,
] as const;

export const fontFamilies = {
  sans: brandConfig.typography.sans,
  serif: brandConfig.typography.serif,
} as const;

export const fontWeights = brandConfig.typography.weights;

/** Spacing scale (px), multiples of 4: space-1 … space-9. */
export const space = brandConfig.spacing;

export const radius = brandConfig.shape;

export const shadows = {
  suave: brandConfig.shadow.soft,
} as const;

export const statusColors = {
  error: brandConfig.support.erro,
  warning: brandConfig.support.aviso,
  success: brandConfig.support.sucesso,
  info: brandColors.petroleo,
} as const;
